export class ZeroEtlJobSyncsFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceTable",
            "baseName": "sourceTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ZeroEtlJobSyncStatus",
            "format": ""
        },
        {
            "name": "targetTable",
            "baseName": "targetTable",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlJobSyncsFilters.attributeTypeMap;
    }
    constructor() {
    }
}
